import { a as SurfaceDark, S as SurfaceDarkInfo, b as SurfaceLight } from '../Surface/index-ead5920e.js';

// eslint-disable-next-line import/prefer-default-export
const getContainer = type => {
  if (type === 'dark') return SurfaceDark;
  if (type === 'blue') return SurfaceDarkInfo;
  return SurfaceLight;
};

export { getContainer as g };
//# sourceMappingURL=utils-11433af1.js.map
